<template>
  <div class="vip-main">
    <!--<div class="vip-scroll">-->
    <div class="vip-rule" @click="showNotice()">
      <img src="./images/main/icon-rule.png" alt="">
    </div>
    <VipHead :isBuy="isBuy"  @showChoice="showChoice">
      <template slot="bg">
        <img class="vip-head-bg" src="./images/main/head.jpg" alt="">
      </template>
      <template slot="userPic">
        <img :src="userPic" v-if="userPic" alt="" >
        <img v-else src="./images/default-avater.png" alt="">
      </template>
      <template slot="userName">
        {{userName || '畅学卡会员' | lengthCut(6)}}
      </template>
      <template slot="endDate">
        {{ endDate | dateFilter}}
      </template>
    </VipHead>
    <div class="durationDays">
      <img src="./images/version2/01.jpg" class="vip-main-desc" alt="">
      <div class="durationDays-time">
        365天+{{durationDays-365}}天={{durationDays}}
      </div>
    </div>

    <img src="./images/version2/02.jpg" class="vip-main-desc"  alt="">

    <div class="vip-main-courses vip-main-section">
      <img src="./images/version2/bg-1.jpg" class="vip-main-section-bg" alt="">
      <div class="vip-main-courses-list">
        <VipShowCase :list="coursesList" :width="296"></VipShowCase>
      </div>
    </div>
    <div class="vip-main-teachers vip-main-section">
      <img src="./images/version2/bg-2.jpg" class="vip-main-section-bg" alt="">
      <div class="vip-main-teachers-list">
        <VipShowCase ref="teacherSwiper"
                     :nameList="nameList"
                     :list="teachersList"
                     :touchVisible="true"
                     :swiper-options="teacherOptions"
                     :width="277"></VipShowCase>
      </div>
      <div class="vip-main-teachers-group">
        <img src="./images/teachers/button-group.png" alt="">
      </div>
      <p class="vip-main-teachers-name">{{nameList[activeIndex]}}</p>
    </div>
    <div class="vip-main-popular vip-main-section">
      <img src="./images/version2/bg-3.jpg" class="vip-main-section-bg" alt="">
      <div class="vip-main-popular-list">
        <VipShowCase :list="popularList" :width="296"></VipShowCase>
      </div>
    </div>
    <div class="vip-main-book vip-main-section">
      <img src="./images/version2/bg-4.jpg" class="vip-main-section-bg" alt="">
      <div class="vip-main-book-list">
        <VipShowCase :list="bookList" :swiper-options="bookOptions" :width="252"></VipShowCase>
      </div>
    </div>
    <img src="./images/version2/bg-5.jpg" class="vip-main-desc" alt="">
    <img src="./images/version2/bg-6.jpg" class="vip-main-desc" alt="">
    <img src="./images/version2/bg-7.jpg" class="vip-main-desc" alt="">
    <img src="./images/version2/bg-8.jpg" class="vip-main-desc" alt="">
    <img src="./images/version2/bg-9.jpg" class="vip-main-desc" alt="">
    <img src="./images/version2/bg-10.jpg" class="vip-main-desc" alt="">
    <div class="vip-main-button" :class="{IOSButton: isAppIos}" @click="showChoice" v-if="!isAppIos && !isFilterMonthVip">
      {{isBuy? ( isPrize ? '立即学习': '立即续费') : '立即开通'}}
    </div>
    <VipChoice
      :cardList="cardList"
      :bonus="bonus"
      :isBuy="isBuy"
      :signStatus="signStatus"
      :isHuaWei="isHuaWei"
      :isAliIos="isAliIos"
      :isAndroidApp="isAppAndroid"
      :isIosApp="isAppIos"
      :isInApp="isInApp"
      :isBuyPush = "isBuyPush"
      :isFilterMonthVip = "isFilterMonthVip"
      @closeCardChoice="closeCardChoice"
      v-if="choiceCardShow && cardList.length"/>
    <Notice ref="notice">
      <div class="notice-main">
        <h1>活动规则</h1>
        <ol>
          <li>单价698元以内课程皆可免费学习
            <p>
              畅学卡用户自购买起，全部课程（包括新课）698以下内容皆可免费学习
            </p>
          </li>
          <li>畅学卡会员怎么学？
            <p>
              会员可在精选好课首页自主选择课程，学习过的课程会自动添加到我的—我的课程列表
            </p>
           </li>
          <!--<li>尊享超低价优惠</li>-->
          <!--<li>可随时取消自动续费服务，取消后不再自动续费</li>-->
        </ol>
        <div class="notice-main-btn" @click="$refs.notice.close()">好的</div>
        <!--<p @click="$router.push('/vipRules')">查看连续包月服务条款</p>-->
      </div>
    </Notice>
    <!--</div>-->
  </div>
</template>

<script>
import os from '@edu-fe/os'
import keys from 'lodash.keys'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import module from '../../modules/vip/vip'
import ShareMaker from '../../lib/shareMaker'

import VipHead from '../../components/Vip/VipHeadMain'
import VipChoice from '../../components/Vip/VipChoice'
import vipSwiper from '../../components/Vip/VipSwiper'
import Notice from '../../components/Notice'

// const INFO_LIST = ['default', 'bookList', 'workList', 'teacherList', 'popularList']

export default {
  data () {
    return {
      // bookList: [],
      // workList: [],
      // teacherList: [],
      // popularList: [],
      choiceCardShow: false,
      realHeight: 0,
      coursesList: [
        require('./images/courses/1.png'),
        require('./images/courses/2.png'),
        require('./images/courses/3.png'),
        require('./images/courses/4.png'),
        require('./images/courses/5.png'),
      ],
      teachersList: [
        require('./images/teachers/1.png'),
        require('./images/teachers/2.png'),
        require('./images/teachers/3.png'),
        require('./images/teachers/4.png'),
        require('./images/teachers/5.png'),
        require('./images/teachers/6.png'),
        require('./images/teachers/7.png'),
        require('./images/teachers/8.png'),
      ],
      activeIndex: 0,
      nameList: [
        '吴晓波',
        '崔璀',
        '老光',
        '路骋',
        '李银河',
        '卢菲菲',
        '杨萃先',
        '陈伟鸿'
      ],
      teacherOptions: {
        effect: 'coverflow',
        grabCursor: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 50,
          depth: 224,
          modifier: 1,
          slideShadows : true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 1500
        },
        on: {
          slideChangeTransitionEnd: () => {
            if (this.teacherSwiper) {
              this.activeIndex = this.teacherSwiper.realIndex
            }
          }
        }
      },
      popularList: [
        require('./images/popular/1.png'),
        require('./images/popular/2.png'),
        require('./images/popular/3.png'),
        require('./images/popular/4.png'),
        require('./images/popular/5.png'),
        require('./images/popular/6.png'),
        require('./images/popular/7.png'),
      ],
      bookList: [
        require('./images/books/1.png'),
        require('./images/books/2.png'),
        require('./images/books/3.png'),
        require('./images/books/4.png'),
        require('./images/books/5.png'),
        require('./images/books/6.png'),
        require('./images/books/7.png'),
        require('./images/books/8.png'),
        require('./images/books/9.png'),
        require('./images/books/10.png'),
        require('./images/books/11.png'),
        require('./images/books/12.png'),
      ],
      bookOptions: {
        slidesPerView: 'auto',
        slidesOffsetAfter: 80,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
      },
    }
  },
  computed: {
    ...mapState(module.name, keys(module.state())),
    ...mapGetters(module.name, keys(module.getters)),
    ...mapState(['vipOperationList', 'durationDays']),
    teacherSwiper () {
      return this.$refs.teacherSwiper.$children[0].swiper
    },
    isHuaWei () {
      return this.$route.query.channel === 'huawei'
    },
    isBuyShow () {
      if (this.signStatus === 2 && this.isAppIos)
        return false
      return true
    },
    isPrize () {
      return this.$route.query.from === 'choujiang'
    },
    isBuyPush () {
      return this.$route.query.from === 'buy_push'
    },
    isAliIos () {
      return os.type === 'ali' && !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  watch: {
    // vipOperationList: {
    //   handler (list) {
    //     if (!list.length) return
    //     list.map(val => {
    //       this[INFO_LIST[val.type]] = val.vipShowCourseList
    //     })
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    closeCardChoice () {
      this.choiceCardShow = false
    },
    showChoice () {
      if (this.isBuy && this.isPrize) {
        this.$router.push('/recommend')
        return
      }
      this.choiceCardShow = !this.choiceCardShow
    },
    showNotice () {
      this.$refs.notice.show()
    },
    topage (courseId) {
      if (this.isInApp) {
        // window.location.href = `courseid://com.wps.excellentclass?id=${courseId}`
        //
        return os.sdk.view.goto('sign-up', { courseId })
      }
      this.$router.push({
        path: '/sign-up',
        query: {
          courseId,
          from: 'H5_vip_card',
        }
      })
    },
    initCardShowVal () {
      if (this.isBuyPush) {
        this.choiceCardShow = true
        return
      }
      if (this.isHuaWei || this.isAppIos || this.isFilterMonthVip) {
        this.choiceCardShow = true
        return
      }
      this.choiceCardShow = false
    }
  },
  filters: {
    dateFilter (val) {
      if (!val)  {
        return '每天不到2块钱，爆款课程免费学，365天成长看得见'
      } else {
        return `${moment(val).format('YYYY年MM月DD日')}过期`
      }
    },
    lengthCut (val, len = 4) {
      if (!val) return ''
      return val.length > len ? `${val.slice(0,len)}..`:val
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  async created () {
    await this.init()
    this.initCardShowVal()
  },
  mounted () {
    new ShareMaker({
      title: '精品课VIP年会员，让优秀成为一种习惯！',
      introduction: '速抢，畅享价值¥14850的知识好礼~',
      imgUrl: this.$store.state.organizationMessage.organLogo,
      link: `https://course-m.auoktalk.com/vip`
    }, location.href, true)
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    VipHead,
    VipShowCase: vipSwiper,
    VipChoice,
    Notice
  }
}
</script>
<style lang="scss" >
@charset "UTF-8";
@import "../../style/main";
@mixin setListStyle($bottom) {
  padding-left: rem(20);
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: rem($bottom);
}
.vip-main {
  font-size: 0;
  padding-bottom: rem(100 );
  &-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    height: rem(117);
    line-height: rem(127);
    font-size: rem(42);
    font-weight: bolder;
    text-align: center;
    color: #fff;
  }
  .durationDays {
    position: relative;
    min-height: rem(800);
    &-time {
      &:before {
        content: '';
        width: rem(65);
        height: rem(27);
        display: block;
        position: absolute;
        top: rem(-20);
        left: rem(270);
        background: {
          image: url("./images/version2/icon.png");
          size: cover;
          repeat: no-repeat;
        };
      }
      position: absolute;
      font-size: rem(46);
      color: #FFDEA5;
      font-weight: bolder;
      height: rem(62);
      line-height: rem(62);
      width: rem(467);
      top: rem(220);
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background: {
        image: url("./images/version2/time-bg.png");
        size: cover;
        repeat: no-repeat;
      };
    }
  }
  &-desc {
    width: 100%;
  }
  &-button {
    background:#161B25 url('images/main/vip-button.png') no-repeat;
    background-size: cover;
  }
  &-section {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    &-bg {
      width: 100%;
    }
  }
  &-book {
    &-list {
      @include setListStyle(50)
    }
  }
  &-courses {
    &-list {
      @include setListStyle(50)
    }
  }
  &-popular {
    &-list {
      @include setListStyle(10)
    }
  }
  &-teachers {
    &-list {
      width:rem(704);
      margin: auto;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: rem(100);
      padding-left: 0;
    }
    &-group {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: rem(70);
      width: rem(256);
      > img {
        width: 100%;
      }
    }
    &-name {
      position: absolute;
      bottom: rem(10);
      width: 100%;
      font-size: rem(32);
      color: #E8BF88;
      text-align: center;
      z-index: 1;
      font-weight: bold;
    }
    .vip-swiper {
      /*padding-left: rem(20);*/
      &-slide {
        margin-right: 0;
      }
    }
  }
  .IOSButton {
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      padding-bottom: rem(84);
      background-size: contain;
    }
  }
  .notice-main {
    padding-bottom: rem(40);
    h1 {
      font-size: rem(36);
      padding: rem(40) 0;
      line-height: 1.5;
    }
    ol {
      text-align: center;
      padding-left: rem(80);
      margin-bottom: rem(30);
    }
    li {
      list-style: decimal;
      width: rem(468);
      line-height: 1.4;
      text-align: left;
      margin: auto;
      padding: rem(10) ;
      color: #666666;
      font-size: rem(30);
    }
    &-btn {
      width: rem(470);
      margin: auto;
      height: rem(70);
      line-height: rem(70);
      color: #fff;
      font-size: rem(32);
      background-image: linear-gradient(to right, #FFB500, #FFB500);
      font-weight: bolder;
      border-radius: rem(10);
    }
    p {
      color: #999999;
      font-size: rem(28);
      padding: rem(30) 0;
    }
  }

}
</style>
